import React from 'react'
import BackgroundVideo from '../components/BackgroundVideo';
import AboutShort from '../components/AboutShort';
import TeamAccolades from '../components/TeamAccolades';
import Achievements from '../components/Achievements';
import InNews from '../components/InNews';
import FeaturedProperties from '../components/FeaturedProperties';

const Home = () => {
  return (
    <div>
      <BackgroundVideo/>
      <AboutShort/>
      <TeamAccolades/>
      <Achievements/>
      <InNews/>
      <FeaturedProperties/>
    </div>
  )
}

export default Home